import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { TopSection } from "./About";
import axios from "axios";

const ServiceDetail = () => {
  const { serviceId } = useParams();
  const [isMobile, setIsMobile] = useState(false);
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/services/${serviceId}`)
      .then((res) => {
        setService(res.data);
        setLoading(false);
      })
      .catch(() => {
        setService(null);
        setLoading(false);
      });
  }, [serviceId]);

  if (loading) {
    return (
      <>
        <TopSection heading="Service Details" />
        <div style={{ textAlign: "center", padding: "50px" }}>Loading...</div>
      </>
    );
  }

  if (!service) {
    return (
      <>
        <TopSection heading="Service Details" />
        <div style={{ textAlign: "center", padding: "50px" }}>Service not found.</div>
      </>
    );
  }

  return (
    <>
      <TopSection heading={service.title}>
        <h2 style={{ fontSize: isMobile ? "16px" : "24px", color: '#DF2126' }}>
          {service.category?.name || ""}
        </h2>
      </TopSection>

      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: isMobile ? "20px" : "40px",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
            gap: isMobile ? "20px" : "40px",
          }}
        >
          <div>
            <div
              style={{
                width: "100%",
                aspectRatio: "4 / 3",
                borderRadius: "20px",
                overflow: "hidden",
                border: "2px solid #f87171",
                marginBottom: "20px",
              }}
            >
              <img
                src={service.images?.[selectedImage]?.src || ""}
                alt={service.title}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </div>
            
            {service.images && service.images.length > 1 && (
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  overflowX: "auto",
                  padding: "10px 0",
                }}
              >
                {service.images.map((img, idx) => (
                  <img
                    key={idx}
                    src={img.src}
                    alt={`${service.title} ${idx + 1}`}
                    onClick={() => setSelectedImage(idx)}
                    style={{
                      width: isMobile ? "60px" : "80px",
                      height: isMobile ? "60px" : "80px",
                      objectFit: "cover",
                      borderRadius: "10px",
                      cursor: "pointer",
                      border: selectedImage === idx ? "3px solid #DF2126" : "2px solid #ddd",
                    }}
                  />
                ))}
              </div>
            )}
          </div>

          <div>
            <h1
              style={{
                fontSize: isMobile ? "24px" : "36px",
                color: "#DF2126",
                marginBottom: "20px",
              }}
            >
              {service.title}
            </h1>
            
            {service.shortDescription && (
              <p
                style={{
                  fontSize: isMobile ? "16px" : "20px",
                  color: "#333",
                  fontWeight: "600",
                  marginBottom: "20px",
                }}
              >
                {service.shortDescription}
              </p>
            )}

            <p
              style={{
                fontSize: isMobile ? "14px" : "18px",
                color: "#555",
                lineHeight: "1.8",
                marginBottom: "30px",
                fontFamily: "Outfit",
              }}
            >
              {service.description}
            </p>

            <a 
              href="tel:+918860229232"
              style={{
                textDecoration: "none",
                display: "inline-block",
                width: isMobile ? "100%" : "auto",
              }}
            >
              <button
                className="btn"
                style={{
                  fontSize: isMobile ? "16px" : "18px",
                  padding: isMobile ? "12px 24px" : "15px 50px",
                  width: isMobile ? "100%" : "auto",
                  display: "block",
                  border: "none",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                Book Now - Call Us
              </button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceDetail;
